import { render } from "./RadialChart.vue?vue&type=template&id=775c6abb"
import script from "./RadialChart.vue?vue&type=script&lang=js"
export * from "./RadialChart.vue?vue&type=script&lang=js"

import "./RadialChart.vue?vue&type=style&index=0&id=775c6abb&lang=scss"
script.render = render

export default script